import React from 'react';
import type {
  AdminClubListItem,
  ClubSubscriptionType,
  ClubNearestEventsType,
} from '../redux/clubs/clubs.api';

interface Props {
  club: AdminClubListItem;
  onClick?: (club: AdminClubListItem) => void;
}

const priceLabel = (
  type: ClubSubscriptionType,
  price: number | null,
): string => {
  if (type === 'free') return 'Free';
  if (type === 'monthly') return price ? `$${price}/month` : 'Monthly';
  if (type === 'one_time') return price ? `$${price}` : 'One-time';
  return 'Free';
};

const dotColor = (n: ClubNearestEventsType): string => {
  if (n === 'now') return '#52e3ff';
  if (n === 'this_week') return '#86efac';
  return '#ffffff';
};

const initial = (firstName?: string, lastName?: string): string =>
  (firstName || lastName || '?').charAt(0).toUpperCase();

export const ClubCard = ({ club, onClick }: Props): React.JSX.Element => {
  const handleClick = (): void => onClick?.(club);
  const owner = club.owner;

  return (
    <button
      type="button"
      className="event-card club-card"
      onClick={handleClick}
    >
      {club.imageUrl ? (
        <img
          className="event-card__image"
          src={club.imageUrl}
          alt=""
          loading="lazy"
        />
      ) : (
        <div className="event-card__image event-card__image--blank" />
      )}

      <div className="event-card__overlay event-card__overlay--top" />
      <div className="event-card__overlay event-card__overlay--bottom" />

      <div className="club-card__top">
        {owner && (
          <>
            {owner.avatarUrl ? (
              <img
                className="event-card__avatar"
                src={owner.avatarUrl}
                alt=""
                style={{ width: 35, height: 35, fontSize: 14 }}
              />
            ) : (
              <div
                className="event-card__avatar event-card__avatar--blank"
                style={{ width: 35, height: 35, fontSize: 14 }}
              >
                {initial(owner.firstName, owner.lastName)}
              </div>
            )}
            <span className="event-card__author">
              {owner.firstName} {owner.lastName}
            </span>
          </>
        )}
        <span
          className="club-card__status-dot"
          style={{ background: dotColor(club.nearestEvents) }}
          title={club.nearestEvents.replace('_', ' ')}
        />
      </div>

      <div className="event-card__content">
        <h3 className="club-card__title">{club.name}</h3>
        <div className="club-card__info">
          <span className="club-card__price">
            {priceLabel(club.subscriptionType, club.subscriptionPrice)}
          </span>
          <span className="event-card__dot event-card__dot--meta" />
          <span className="club-card__members">
            {club.memberCount}{' '}
            {club.memberCount === 1 ? 'member' : 'members'}
          </span>
        </div>
        <div className="event-card__footer">
          <span className="event-card__view-btn">View</span>
        </div>
      </div>
    </button>
  );
};
